import React from 'react';
import Banner from './Banner';
import TwoColumnIntro from './TwoColumnIntro';
import ArticleContent from './ArticleContent';
import Testimonials from './Testimonials';
import CTAButton from './CTAButton';
import StickyBottomBanner from './StickyBottomBanner';
import { StarIcon } from 'lucide-react';
const Advertorial = () => {
  return <div className="bg-white font-sans relative" data-id="element-3">
      <Banner data-id="element-4" />
      <div className="flex flex-col md:flex-row max-w-6xl mx-auto" data-id="element-5">
        {/* Left Content Column */}
        <div className="md:w-2/3 md:pr-8" data-id="element-6">
          <TwoColumnIntro data-id="element-7" />
          <ArticleContent data-id="element-8" />
          <div className="p-6 bg-gray-100 my-8 rounded-lg text-center" data-id="element-9">
            <h3 className="text-xl font-bold mb-4" data-id="element-10">
              What Men are saying about Drift™
            </h3>
            <div className="flex items-center justify-center mb-4" data-id="element-11">
              <div className="flex text-yellow-400" data-id="element-12">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-13" />)}
              </div>
              <span className="ml-2 text-gray-700" data-id="element-14">47,819 Reviews</span>
            </div>
            <Testimonials data-id="element-15" />
            <div className="mt-8" data-id="element-16">
              <a href="https://www.thaura.co/products/drift" className="block w-full" data-id="element-17">
                <button className="bg-[#84f75d] hover:bg-[#6dd84a] text-black font-bold py-3 px-8 rounded-md w-full text-lg transition duration-300" data-id="element-18">
                  Try Drift™ Risk-Free Now – Save 50% Today™ →
                </button>
              </a>
            </div>
          </div>
          <div className="text-xs text-gray-500 text-center p-4 border-t" data-id="element-19">
            *These statements have not been evaluated by the Food and Drug
            Administration. This product is not intended to diagnose, treat,
            cure, or prevent any disease. Results may vary.
          </div>
        </div>
        {/* Right Sticky Product Column - Placeholder for desktop only, actual content in TwoColumnIntro */}
        <div className="hidden md:block md:w-1/3" data-id="element-20">
          {/* This is just a placeholder div to reserve space */}
        </div>
      </div>
      <StickyBottomBanner data-id="element-21" />
    </div>;
};
export default Advertorial;